import create from 'zustand';

interface IStickyNavPositionState {
  readonly stickyBuyBarIsInView: boolean;
  readonly setStickyBuyBarIsInView: (inView: boolean) => void;
}

const useStickyBuyBarStore = create<IStickyNavPositionState>((set) => ({
  stickyBuyBarIsInView: false,
  setStickyBuyBarIsInView: (inView: boolean) =>
    set({ stickyBuyBarIsInView: inView }),
}));

export default useStickyBuyBarStore;
